/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DiskUtilizationMetricDetail {
    getFixupPrototypeFunction() { return DiskUtilizationMetricDetail.fixupPrototype; }

    static newInstance(model: Partial<DiskUtilizationMetricDetail>): DiskUtilizationMetricDetail {
        let obj = Object.assign(new DiskUtilizationMetricDetail(), model);
        DiskUtilizationMetricDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DiskUtilizationMetricDetail>): DiskUtilizationMetricDetail {
        if (!model) return null;
        return DiskUtilizationMetricDetail.newInstance(<DiskUtilizationMetricDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DiskUtilizationMetricDetail) {
        if (!obj) return;

        models.DiskUtilizationMetricDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DiskUtilizationMetricDetail): boolean {
        Object.setPrototypeOf(obj, DiskUtilizationMetricDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.free === undefined) {
            this.free = 0;
        }
        if (this.used === undefined) {
            this.used = 0;
        }
    }

    /**
     * Time stamp in string for which metrics are being measured.
     */
    date: string;

    /**
     * Free Space for the metric in the provided time frame.
     */
    free: number;

    /**
     * Utilized Space for the metric in the provided time frame.
     */
    used: number;

}
